export default __webpack_public_path__ + "static/media/lock.958ff040.svg";